import script from "./selectMode.vue?vue&type=script&setup=true&lang=js"
export * from "./selectMode.vue?vue&type=script&setup=true&lang=js"

import "./selectMode.vue?vue&type=style&index=0&id=5e64ca62&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e64ca62"]])

export default __exports__